import { render, staticRenderFns } from "./BreadcrumbEdit.vue?vue&type=template&id=4ff003e3&"
import script from "./BreadcrumbEdit.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports